import { t } from "@lingui/core/macro";

import { HoleCount } from "../../TimeSlotList/components/__generated__/TimeSlotListInternalQuery.graphql";

export const holeCountLabel = (value: HoleCount | null): string | null => {
  if (!value) {
    return null;
  }

  return value === "EIGHTEEN" ? t`18 holes` : t`9 holes`;
};
